import type { CustomFile } from '../types';

import getRelativePathData from './getRelativePathData';

// ----------------------------------------------------------------------------

function getRootFolderNames(files: CustomFile[]): string[] {
    const rootFolders = new Set<string>();

    for (const file of files) {
        const pathData = getRelativePathData(file);

        if (pathData?.rootFolder == null) {
            continue;
        }

        rootFolders.add(pathData.rootFolder);
    }

    return Array.from(rootFolders);
}

// ----------------------------------------------------------------------------

export default getRootFolderNames;
